import { LogLevel } from "@azure/msal-browser";


/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
	auth: {
		// clientId: "Enter_the_Application_Id_Here", // This is the ONLY mandatory field that you need to supply.
		clientId: "f3ee8e23-49d4-4960-b5d1-98067564029f", // This is the ONLY mandatory field that you need to supply.
		// authority: "https://login.microsoftonline.com/Enter_the_Tenant_Info_Here", // Defaults to "https://login.microsoftonline.com/common"
		authority: "https://login.microsoftonline.com/0a77c881-1d61-41db-8e03-b9737a0e8f52", // Defaults to "https://login.microsoftonline.com/common"
		redirectUri: process.env.REACT_APP_REDIRECT_URI, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
		navigateToLoginRequestUrl: true
	},
	cache: {
		cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						console.info(message);
						return;
					case LogLevel.Verbose:
						console.debug(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
					default:
						console.warn("Error: msalConfig()");
						return;
				}
			},
			logLevel: LogLevel.Error  // shows only error messages
		},

	},
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
	graphMe: {
		endpoint: "https://graph.microsoft.com/v1.0/me",
		scopes: ["User.Read"],
	}
};
